export default __webpack_public_path__ + "5afb1f7c7464ace62524659b56fad329.ttf";